<app-direct-nav
  *ngIf="id && origin && directNav"
  [content]="directNav"
></app-direct-nav>

<div *ngFor="let block of directClient">
  <app-hero-block
    *ngIf="block.block_type === 'hero'"
    [content]="block"
  ></app-hero-block>
  <app-news-block
    *ngIf="block.block_type === 'news'"
    [content]="block"
  ></app-news-block>
  <app-carousel
    *ngIf="block.block_type === 'carousel'"
    [content]="block.children"
  ></app-carousel>
  <app-direct-block
    *ngIf="block.block_type === 'static'"
    [content]="block"
  ></app-direct-block>
</div>

<app-direct-black-box
  *ngIf="directBlackBox"
  [content]="directBlackBox"
></app-direct-black-box>

<app-direct-footer
  *ngIf="id && origin && directFooter"
  [content]="directFooter"
></app-direct-footer>
